import React from 'react';

export const Medlem = () => {
  return (
    <>
      Medlem page
    </>
  )
}